import { fetchAllEntitiesForDownloadAction } from "../actions/fetchAllEntitiesForDownloadAction";

// ── CSV helpers ───────────────────────────────────────────────────────────────
const toCSV = (rows, columns) => {
  const header = columns.map((c) => `"${c.label}"`).join(",");
  const body = rows.map((row) =>
    columns
      .map((c) => {
        const val = c.value(row) ?? "";
        return `"${String(val).replace(/"/g, '""')}"`;
      })
      .join(","),
  );
  return [header, ...body].join("\r\n");
};

const triggerDownload = (csv, filename) => {
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

const fmtBool = (v) => (v === true ? "Yes" : v === false ? "No" : "");

// ── Columns — mapped from raw API response fields ─────────────────────────────

const PRIMARY_COLS = [
  { label: "Entity ID", value: (r) => r.entityId },
  { label: "Entity Name", value: (r) => r.entityName },
  { label: "Category", value: (r) => r.entityCategory },
  { label: "LOB Type", value: (r) => r.entityLOBType },
  { label: "AA Department", value: (r) => r.aaDepartmentFunction },
  { label: "Parent", value: (r) => r.parentName },
  { label: "Email", value: (r) => r.emailAddress },
  { label: "SPOC Email", value: (r) => r.spoC_EmailAddress },
  { label: "Entity Type", value: (r) => r.entityType },
  { label: "Require KYC", value: (r) => fmtBool(r.requireKYC) },
  { label: "Invoice Required", value: (r) => fmtBool(r.invoiceRequired) },
  { label: "Status", value: (r) => (r.isVerified ? "Approved" : "Pending") },
];

const CONTACT_COLS = [
  {
    label: "Contact Person",
    value: (r) => r.contactPersonDetails?.contactPersonName,
  },
  { label: "Designation", value: (r) => r.contactPersonDetails?.designation },
  { label: "Mobile", value: (r) => r.contactPersonDetails?.mobileNumber },
  {
    label: "Contact Email",
    value: (r) => r.contactPersonDetails?.contactPersonEmail,
  },
];

const ADDRESS_COLS = [
  { label: "Pin Code", value: (r) => r.pinCode },
  { label: "City", value: (r) => r.city },
  { label: "State", value: (r) => r.state },
  { label: "Address", value: (r) => r.address },
];

const KYC_COLS = [
  {
    label: "PAN Number",
    value: (r) =>
      r.panDetails?.panCardNumber || r.proprietorshipDetails?.panCardNumber,
  },
  // { label: "Trade Name", value: (r) => r.tradeName },
];

const GST_COLS = [
  { label: "GST Registered", value: (r) => fmtBool(r.isGSTRegistered) },
  {
    label: "GST Numbers",
    value: (r) =>
      (r.gstList || [])
        .filter((g) => g.gstNumber)
        .map((g) => g.gstNumber)
        .join("; "),
  },
  {
    label: "GST States",
    value: (r) =>
      (r.gstList || [])
        .filter((g) => g.state)
        .map((g) => g.state)
        .join("; "),
  },
];

const MSME_COLS = [
  {
    label: "MSME Registered",
    value: (r) => fmtBool(r.msmeDetails?.isRegisteredUnderMSME),
  },
  {
    label: "MSME Reg. Number",
    value: (r) => r.msmeDetails?.msmeRegistrationNumber,
  },
];

const BANK_COLS = [
  { label: "Bank Name", value: (r) => r.bankDetails?.bankName },
  { label: "Account Number", value: (r) => r.bankDetails?.accountNumber },
  { label: "IFSC Code", value: (r) => r.bankDetails?.ifscCode },
  { label: "Account Type", value: (r) => r.bankDetails?.accountType },
  { label: "Branch Name", value: (r) => r.bankDetails?.branchName },
  { label: "Beneficiary", value: (r) => r.bankDetails?.beneficiaryName },
];

const ALL_COLS = [
  ...PRIMARY_COLS,
  // ...CONTACT_COLS,
  ...ADDRESS_COLS,
  ...KYC_COLS,
  ...GST_COLS,
  // ...MSME_COLS,
  // ...BANK_COLS,
];

// ── Public API ────────────────────────────────────────────────────────────────

export const downloadEntityData = async (filters = {}) => {
  const { success, data, error } =
    await fetchAllEntitiesForDownloadAction(filters);

  if (!success || !data.length) {
    alert(error ? `Download failed: ${error}` : "No data to download.");
    return;
  }

  const ts = new Date().toISOString().slice(0, 10);
  triggerDownload(toCSV(data, ALL_COLS), `entities_${ts}.csv`);
};
